import { COMPLETE_TOUR, SET_UP, EXECUTE_ACTION } from "./constants";

export const completeTour = tourId => ({
  type: COMPLETE_TOUR,
  payload: tourId
});

export const executeAction = actionId => ({
  type: EXECUTE_ACTION,
  payload: actionId
})

export const setUp = (loadData, executeAction, completeTour, saveAchievement) => ({
  type: SET_UP,
  payload: {
    loadData,
    executeAction,
    completeTour,
    saveAchievement
  }
})
